// 한국어 조사 고르기 — "기준값을(를)"처럼 괄호로 병기하지 않고 앞말 받침에 맞춰 붙인다.

type Pair = '을/를' | '은/는' | '이/가' | '으로/로';

// 숫자는 읽는 소리로 받침을 정한다(0 영, 1 일, 3 삼, 6 육, 7 칠, 8 팔 → 받침 있음 / 2 이, 4 사, 5 오, 9 구 → 없음).
const DIGIT_JONG: Record<string, number> = {
  '0': 21,
  '1': 8,
  '2': 0,
  '3': 16,
  '4': 0,
  '5': 0,
  '6': 1,
  '7': 8,
  '8': 8,
  '9': 0,
};

/** 마지막 글자의 종성 인덱스(0 = 받침 없음, 8 = ㄹ). 판단할 수 없으면 null. */
function finalConsonant(word: string): number | null {
  const last = word.replace(/[\s"'”’)\]]+$/, '').at(-1);
  if (!last) {
    return null;
  }
  if (last in DIGIT_JONG) {
    return DIGIT_JONG[last] ?? null;
  }
  const code = last.charCodeAt(0) - 0xac00;
  if (code < 0 || code > 11171) {
    return null;
  }
  return code % 28;
}

/** 앞말에 맞는 조사를 붙인다 — josa('기준값', '을/를') → '기준값을' */
export function josa(word: string, pair: Pair) {
  const [withBatchim = '', withoutBatchim = ''] = pair.split('/');
  const jong = finalConsonant(word);
  if (jong === null) {
    return `${word}${withBatchim}(${withoutBatchim})`;
  }
  // "으로/로"는 ㄹ 받침 뒤에도 "로"를 쓴다(서울로).
  const hasBatchim = pair === '으로/로' ? jong !== 0 && jong !== 8 : jong !== 0;
  return `${word}${hasBatchim ? withBatchim : withoutBatchim}`;
}
